import React from 'react';

import { TableContainerWithSorting } from 'components';

import { GetDetailTableColumns, SummaryTableRow } from './table-schema';

interface DetailTableProps {
  data: SummaryTableRow[] | null;
  isLoading: boolean;
}

const DetailTable: React.FC<DetailTableProps> = ({ data, isLoading = false }) => {
  const columns = Object.values(GetDetailTableColumns());

  if (!data) {
    return null;
  }

  return (
    <TableContainerWithSorting<SummaryTableRow>
      columns={columns}
      scroll={{ y: 250 }}
      dataSource={data}
      loading={isLoading}
    />
  );
};
export default DetailTable;
